<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar Cancha</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-2">
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="nombre"
                prepend-icon="mdi-account"
                label="Nombre Cancha *"
                maxlength="50"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="9" sm="4" md="4">
              <v-select
                :items="tiposCancha"
                v-model="tipoCancha"
                item-text="text"
                item-value="value"
                label="Tipo de Cancha"
                dense
                prepend-icon="mdi-account"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="tipoPiso"
                prepend-icon="mdi-account"
                label="Tipo Piso"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="tipoParedes"
                prepend-icon="mdi-account"
                label="Tipo Paredes"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-account"
                label="Observaciones"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarCancha"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    nombre: null,
    tiposCancha: [
      { text: "Al aire libre", value: "Al aire libre" },
      { text: "Techada", value: "Techada" },
    ],
    tipoCancha: null,
    tipoPiso: null,
    tipoParedes: null,
    observaciones: null,
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
  }),

  props: ["visible", "idCancha"],

  computed: {
    show: {
      get() {
        if (this.visible) {
          this.buscarDatosCancha();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    vaciarModels() {
      this.nombre = null;
      this.tipoCancha = null;
      this.tipoPiso = null;
      this.tipoParedes = null;
      this.observaciones = null;
    },
    buscarDatosCancha() {
      let self = this;

      axios
        .get("/Cancha/BuscarDatosCancha?", {
          params: {
            idCancha: this.idCancha,
          },
        })
        .then((response) => {
          self.nombre = response.data.nombre;
          self.tipoCancha = response.data.tipoCancha;
          self.tipoPiso = response.data.tipoPiso;
          self.tipoParedes = response.data.tipoParedes;
          self.observaciones = response.data.observaciones;
        })
        .catch((error) => {});
    },
    modificarCancha() {
      this.$swal({
        title: "Modificar Cancha",
        text: "¿Desea modificar los datos de la cancha?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosCancha = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idCancha: this.idCancha,
            nombre: this.nombre,
            tipoCancha: this.tipoCancha,
            tipoPiso: this.tipoPiso,
            tipoParedes: this.tipoParedes,
            observaciones: this.observaciones,
          };
          let self = this;
          axios
            .post("/Cancha/ModificarCancha", datosCancha)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title: "Ya existe una cancha registrada con ese nombre",
                  vm: self,
                });
              } else {
                self.$refs.form.resetValidation();

                document.getElementsByClassName(
                  "v-dialog--active"
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Cancha modificada exitosamente",
                  vm: self,
                });
                self.$emit("canchaModificada");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "La cancha no pudo ser modificada",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
